
Checkout.Payment.OnAccount = function(checkout, payment) {
	var onaccount = this;

	this.label = 'On Account';

	this.$tpl = $('#payment-method-onaccount-tpl');
	this.$wrap = false;

	this.init = function() {
		onaccount.$wrap = onaccount.$tpl
			.clone(true)
			.removeAttr('id');
	};

	this.getData = function() {
		return {};
	};

	this.init();
};

